import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  NotificationHubService,
  NotificationItem
} from 'src/app/providers/notification-hub/notification-hub.service';
import { AttachmentPreviewDialogComponent } from '../attachment-preview-dialog/attachment-preview-dialog.component';
import { NotificationAttachment } from 'src/app/shared/models/notification-attachment.model';
import { NotificationAttachmentService } from 'src/app/shared/services/notification-attachment.service';

@Component({
  selector: 'app-important-notifications-modal',
  templateUrl: './important-notifications-modal.component.html',
  styleUrls: ['./important-notifications-modal.component.scss']
})
export class ImportantNotificationsModalComponent {
  @Input() items: NotificationItem[] = [];

  constructor(
    public activeModal: NgbActiveModal,
    private hub: NotificationHubService,
    private ngbModal: NgbModal,
    private attachmentService: NotificationAttachmentService
  ) {}

  markRead(item: NotificationItem): void {
    this.hub.markRead(item);
    item.read = true;
  }

  markAllRead(): void {
    this.items.filter((i) => !i.read).forEach((i) => this.hub.markRead(i));
    this.hub.clearImportantQueue();
    this.activeModal.close();
  }

  dismiss(): void {
    this.hub.clearImportantQueue();
    this.activeModal.dismiss();
  }

  onCardClick(item: NotificationItem): void {
    this.markRead(item);
  }

  getAttachments(item: NotificationItem): NotificationAttachment[] {
    return this.hub.getAttachments(item);
  }

  categoryLabel(key: string): string {
    const labels: Record<string, string> = {
      general: 'General',
      info: 'General',
      alert: 'Alerts',
      announcement: 'Announcements',
      reminder: 'Reminders'
    };
    return labels[key] || key.charAt(0).toUpperCase() + key.slice(1);
  }

  categoryIcon(category: string): string {
    const map: Record<string, string> = {
      general: 'info',
      info: 'info',
      alert: 'alert-triangle',
      announcement: 'volume-2',
      reminder: 'clock'
    };
    return map[category] || 'bell';
  }

  priorityLabel(priority: string): string {
    return priority.charAt(0).toUpperCase() + priority.slice(1);
  }

  relativeTime(date: Date): string {
    const diff = Math.floor((Date.now() - new Date(date).getTime()) / 1000);
    if (diff < 60) return 'Just now';
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    return new Date(date).toLocaleDateString();
  }

  openAttachmentPreview(attachment: NotificationAttachment): void {
    const modalRef = this.ngbModal.open(AttachmentPreviewDialogComponent, {
      size: 'xl',
      windowClass: 'attachment-preview-modal',
      backdrop: true,
      keyboard: true,
      centered: true
    });
    modalRef.componentInstance.attachment = attachment;
  }

  downloadAttachmentFile(attachment: NotificationAttachment): void {
    this.attachmentService.downloadFile(attachment);
  }
}
